import { ProFormSelect } from "@ant-design/pro-components";
import { useCallback, useEffect, useState } from "react";
import { getSelectLists } from "@api";
import { SelectProps, Pagination } from "antd";
import { get, uniqBy } from "lodash-es";

export interface Props {
  field: string;
  label: string;
  apiUrl?: string;
  fieldProps?: SelectProps;
  disabled?: boolean;
  dataKey?: string;
  isUniqBy?: string;
  isShowPagination?: boolean;
}

const NetworkSelect = ({
  field,
  label,
  apiUrl,
  fieldProps,
  disabled,
  dataKey = "data.body",
  isUniqBy,
  isShowPagination = false,
}: Props) => {
  const [options, setOptions] = useState<any[]>([]);
  const size = 50;
  const [pageParams, setPageParams] = useState({
    current: 1,
    size,
    total: 0,
  });

  const getData = useCallback(() => {
    if (!apiUrl) return;
    getSelectLists(apiUrl, pageParams).then((res: any) => {
      const data = get(res, dataKey, []);
      setOptions(
        isUniqBy
          ? uniqBy(
              data
                .map((item: any) =>
                  item.attribute ? { ...item, ...item.attribute } : item
                )
                .filter((item: any) => item[isUniqBy]),
              isUniqBy
            )
          : data
      );
      setPageParams((prev) => {
        prev.total = res.data.body?.totalElements;
        return prev;
      });
    });
  }, [apiUrl, dataKey, pageParams, isUniqBy]);

  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <ProFormSelect
      options={options}
      name={field}
      fieldProps={{
        style: {
          width: 150,
        },
        showSearch: true,
        dropdownRender: (item) => {
          return (
            <div>
              {item}
              {isShowPagination && pageParams.total > size && (
                <Pagination
                  size="small"
                  className="my-2"
                  align="end"
                  pageSize={pageParams.size}
                  current={pageParams.current}
                  onChange={(page) => {
                    setPageParams((prev) => {
                      prev.current = page;
                      return prev;
                    });
                    getData();
                  }}
                  total={pageParams.total}
                />
              )}
            </div>
          );
        },
        ...fieldProps,
      }}
      disabled={disabled}
      label={label}
    />
  );
};

export default NetworkSelect;
